import { ReactNode } from 'react';
import { useLanguage } from '../lib/LanguageContext';

interface ApiHelpButtonProps {
  className?: string;
  children?: ReactNode;
}

export function ApiHelpButton({ className, children }: ApiHelpButtonProps) {
  const { language } = useLanguage();
  const helpUrl = `/api-help-${language}.html`;

  return (
    <a
      href={helpUrl}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children ?? 'API Docs'}
    </a>
  );
}
